__turbopack_context__.v({
  "cloud__card": "clouds-module__LT0lHa__cloud__card",
  "wrapper": "clouds-module__LT0lHa__wrapper",
});
